import api from './index';
import { setToken } from '../utils/authUtils';

const BASE = '/additionalLocationDeltaWorktypeChannel';

export const getAdditionalWorktypeChannelForLocation = async (location) => {
    return api.get(`${BASE}?location=${location}`, await setToken()).then((res) => res.data);
};
